import React, { useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import AboutComp from "../components/about-comp";

// Maine function ka naam 'ContactUs' se 'AboutUs' kar diya hai kyunki yeh About page lag raha hai
function AboutUs() {
  useEffect(() => {
    // 1. Helper function to load script
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = false; // Sequence ke liye zaroori
        
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load failed: ${src}`));

        document.body.appendChild(script);
      });
    };

    // 2. Scripts List
    const scripts = [
      "assets/js/jquery.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/purecounter.js",
      "assets/js/range-slider.js",
      "assets/js/nice-select.js",
      "assets/js/swiper-bundle.min.js",
      "assets/js/isotope-pkgd.js",
      "assets/js/slick.min.js",
      "assets/js/wow.js",
      "assets/js/countdown.js",
      "assets/js/magnific-popup.js",
      "assets/js/imagesloaded-pkgd.js",
      "assets/js/parallax.js",
      "assets/js/slider.js",
      "assets/js/main.js"
    ];

    // 3. Load Function (One by one)
    const loadAllScripts = async () => {
      try {
        for (const src of scripts) {
          await loadScript(src);
        }
      } catch (error) {
        console.error("Script loading error:", error);
      }
    };

    loadAllScripts();

    // Cleanup
    return () => {
      scripts.forEach(src => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <>
      <Header />
      <AboutComp />
      <Footer />
    </>
  );
}

export default AboutUs;